export enum MetaValueType {
	String ="STRING",
	Int = "INT",
	Boolean = "BOOLEAN",
	Date = "DATE",
	DropDown = "DROPDOWN",
	RadioButtons = "RADIOBUTTONS"
}
